import { S as t, a as e, b as r, c as l } from "../../style-B5VBq8yY.mjs";
const a = () => {
};
a.Text = t;
a.Link = e;
a.Title = r;
a.Paragraph = l;
export {
  a as GrowTypography
};
//# sourceMappingURL=AntTypography.js.map
